<h1 mat-dialog-title>
    {{ details.omschrijving }}
    <mat-progress-bar mode="indeterminate" *ngIf="isLoadingDetails"></mat-progress-bar>
</h1>
<div *ngIf="isAlternativeItem" class="alert alert-warning mb-0">
    Vul een artikelnummer in om diverse velden automatisch
    in te laten vullen
</div>


<mat-dialog-content>
    <div class="row">
        <div class="col-sm-3">
            <div class="card">
                <div class="card-header">
                    Aanvraagcondities
                </div>
                <div class="card-body">
                    <div class="card-text">
                        <div class="form-group row">
                            <label for="OfferteAanvraagOmschrijving"
                                   class="col-sm-5 col-form-label">Omschrijving</label>
                            <div class="col-sm-7">
                                <span id="OfferteAanvraagOmschrijving"
                                      class="form-control-plaintext">{{ details.offerteAanvraagOmschrijving }}</span>
                            </div>
                        </div>

                        <div class="form-group row">
                            <label for="Debiteur" class="col-sm-5 col-form-label">Debiteur</label>
                            <div class="col-sm-7">
                                <span id="Debiteur" class="form-control-plaintext">{{ details.debiteurNaam }}</span>
                            </div>
                        </div>

                        <div class="font-weight-bold kp-heading">Afleverperiode</div>

                        <div class="form-group row">
                            <label for="VanJaarWeek" class="col-sm-5 col-form-label">Van jaar-week</label>
                            <div class="col-sm-7">
                                <span id="VanJaarWeek"
                                      class="form-control-plaintext">
                                    {{ details.afleverperiodeVanJaar }}
                                    -{{ details.afleverperiodeVanWeek }}
                                </span>
                            </div>
                        </div>

                        <div class="form-group row">
                            <label for="TotJaarWeek" class="col-sm-5 col-form-label">Tot jaar-week</label>
                            <div class="col-sm-7">
                                <span id="TotJaarWeek"
                                      class="form-control-plaintext">
                                    {{ details.afleverperiodeTotJaar }}
                                    -{{ details.afleverperiodeTotWeek }}
                                </span>
                            </div>
                        </div>

                        <div class="form-group row">
                            <label for="DeadlineInkoop" class="col-sm-5 col-form-label">Deadline inkoop</label>
                            <div class="col-sm-7">
                                <span id="DeadlineInkoop" class="form-control-plaintext">
                                    {{
                                        details.deadlineInkoopDate | date:"dd-MM-yyy HH:mm"
                                    }}
                                </span>
                            </div>
                        </div>

                        <div class="form-group row">
                            <label for="DeadlineLeverancier" class="col-sm-5 col-form-label">
                                Deadline
                                leverancier
                            </label>
                            <div class="col-sm-7">
                                <span id="DeadlineLeverancier" class="form-control-plaintext">
                                    {{
                                        details.deadlineLeverancierDate |
                                            date:"dd-MM-yyy HH:mm"
                                    }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-header">
                    Aanvraagregelcondities
                </div>
                <div class="card-body">
                    <div class="card-text">
                        <div class="form-group row">
                            <label for="Referentie" class="col-sm-5 col-form-label">Referentie (id)</label>
                            <div class="col-sm-7">
                                <span id="Referentie" class="form-control-plaintext">{{ details.sourceId }}</span>
                            </div>
                        </div>

                        <div class="form-group row">
                            <label for="GeldigheidKwekersaanbieding" class="col-sm-5 col-form-label">
                                Geldigheid
                                kwekersaanbieding
                            </label>
                            <div class="col-sm-7">
                                <mat-form-field *ngIf="!isDisabled; else elseBlock1">
                                    <input id="GeldigheidKwekersaanbieding"
                                           [(ngModel)]="details.leverancierDetails.geldigheidKwekersaanbiedingTot"
                                           matInput
                                           [matDatepicker]="picker"
                                           (change)="onChangeGeldigheidKwekersaanbieding($event)">
                                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                    <mat-datepicker #picker></mat-datepicker>
                                </mat-form-field>
                                <ng-template #elseBlock1>
                                    <span class="form-control-plaintext">
                                        {{
                                            details.leverancierDetails.geldigheidKwekersaanbiedingTot | date: 'dd-MM-yyyy'
                                        }}
                                    </span>
                                </ng-template>
                            </div>
                        </div>

                        <div class="form-group row">
                            <label for="Handeltype" class="col-sm-5 col-form-label">Handeltype</label>
                            <div class="col-sm-7">
                                <span id="Handeltype" class="form-control-plaintext">{{ details.handelType }}</span>
                            </div>
                        </div>

                        <div class="form-group row">
                            <label for="Verlading" class="col-sm-5 col-form-label">Verlading</label>
                            <div class="col-sm-7">
                                <span id="Verlading" class="form-control-plaintext">{{ details.verladingType }}</span>
                            </div>
                        </div>

                        <div class="form-group row">
                            <label for="Stickeren" class="col-sm-5 col-form-label">Stickeren</label>
                            <div class="col-sm-3">
                                <span id="Stickeren"
                                      class="form-control-plaintext">{{ details.isSticker | yesno }}</span>
                            </div>
                        </div>
                        <div class="form-group row" *ngIf="details.prijsperiodeAndStaffelsEnabled">
                            <label for="hasPurchasePricePeriods"
                                   class="col-sm-5 col-form-label">Inkoopprijsperiodes</label>
                            <div class="col-sm-3">
                                <span id="hasPurchasePricePeriods"
                                      class="form-control-plaintext">{{ details.hasPurchasePricePeriods | yesno }}</span>
                            </div>
                        </div>
                        <div class="form-group row" *ngIf="details.prijsperiodeAndStaffelsEnabled">
                            <label for="hasTieredPricing" class="col-sm-5 col-form-label">Staffels</label>
                            <div class="col-sm-3">
                                <span id="hasTieredPricing"
                                      class="form-control-plaintext">{{ details.hasTieredPricing | yesno }}</span>
                            </div>
                        </div>

                        <div class="form-group row">
                            <label for="Stickeren1" class="col-sm-5 col-form-label">Stickerlocatie</label>
                            <div class="col-sm-7">
                                <span id="Stickeren1"
                                      class="form-control-plaintext">{{ details.locatieProductlabelCode1 }}</span>
                            </div>
                            <label for="Stickeren2" class="col-sm-5 col-form-label">&nbsp;</label>
                            <div class="col-sm-7">
                                <span id="Stickeren2"
                                      class="form-control-plaintext">{{ details.locatieProductlabelCode2 }}</span>
                            </div>
                            <label for="Stickeren3" class="col-sm-5 col-form-label">&nbsp;</label>
                            <div class="col-sm-7">
                                <span id="Stickeren3"
                                      class="form-control-plaintext">{{ details.locatieProductlabelCode3 }}</span>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-header">
                    Afbeeldingen
                </div>
                <div class="card-body">
                    <div class="card-text">
                        <div id="photoCarouselIndicators" class="kp-carousel carousel slide"
                             *ngIf="details.photos != undefined && details.photos.length > 0; else elseBlock33"
                             data-ride="carousel">
                            <ol *ngIf="details.photos != undefined && details.photos.length > 1"
                                class="carousel-indicators">
                                <li data-target="#photoCarouselIndicators" data-slide-to="0"
                                    *ngFor="let fotoUrl of details.photos; let first = first;"
                                    [class.active]="first"></li>
                            </ol>
                            <div class="carousel-inner">
                                <div class="carousel-item"
                                     *ngFor="let fotoUrl of details.photos; let first = first;"
                                     [class.active]="first">
                                    <img src="{{fotoUrl}}" class="d-block w-100" alt="Productfoto"
                                         onerror="this.src='./assets/img/image-not-available.png';">
                                </div>
                            </div>
                            <a *ngIf="details.photos != undefined && details.photos.length > 1"
                               class="carousel-control-prev"
                               href="#photoCarouselIndicators" role="button" data-slide="prev">
                                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                <span class="sr-only">Vorige</span>
                            </a>
                            <a *ngIf="details.photos != undefined && details.photos.length > 1"
                               class="carousel-control-next"
                               href="#photoCarouselIndicators" role="button" data-slide="next">
                                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                <span class="sr-only">Volgende</span>
                            </a>
                        </div>
                        <ng-template #elseBlock33>Geen afbeeldingen beschikbaar.</ng-template>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-sm-9">
            <div class="row">
                <div class="col-sm-4">
                    <div class="card">
                        <div class="card-header">
                            Productkenmerken
                        </div>
                        <div class="card-body">
                            <div class="card-text">

                                <div class="form-group row">
                                    <label for="Kwekerartikel" class="col-sm-5 col-form-label">Artikelnummer</label>
                                    <div class="col-sm-7">
                                        <span *ngIf="isDisabled || !isAlternativeItem; else elseEditSupplierAssignedId"
                                              id="Kwekerartikel"
                                              class="form-control-plaintext">{{ details.supplierAssignedId }}</span>
                                        <ng-template #elseEditSupplierAssignedId>
                                            <mat-form-field id="SupplierAssignedId">
                                                <input type="text" #supplierAssignedId
                                                       [formControl]="controlSupplierAssignedId"
                                                       matInput
                                                       [(ngModel)]="details.leverancierDetails.supplierAssignedId"
                                                       [matAutocomplete]="auto" />
                                                <mat-autocomplete #auto="matAutocomplete"
                                                                  (optionSelected)="supplierAssignedIdSelected($event)">
                                                    <mat-option (onSelectionChange)="supplierAssignedId.value != undefined && onEnter($event)"
                                                                *ngFor="let option of filteredAssignedIds | async"
                                                                [value]="option.id">
                                                        {{ option.text }}
                                                    </mat-option>
                                                </mat-autocomplete>
                                            </mat-form-field>
                                        </ng-template>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label for="Omschrijving" class="col-sm-5 col-form-label">Omschrijving</label>
                                    <div class="col-sm-7">
                                        <span *ngIf="details.leverancierDetails.id || isDisabled; else elseEditDescription"
                                              class="form-control-plaintext">{{ details.leverancierDetails.omschrijving || details.omschrijving }}</span>
                                        <ng-template #elseEditDescription>
                                            <mat-form-field id="Omschrijving">
                                                <input type="text" matInput [formControl]="omschrijvingControl" />
                                                <span matSuffix *ngIf="omschrijvingControl.invalid">
                                                    &nbsp; <i class="fa-solid fa-exclamation"
                                                              style="color: red;"></i>
                                                </span>
                                            </mat-form-field>
                                        </ng-template>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label for="AantalGevraagd" class="col-sm-5 col-form-label">Aantal gevraagd</label>
                                    <div class="col-sm-7">
                                        <span id="AantalGevraagd" class="form-control-plaintext">
                                            {{ details.aantal }}
                                            {{ details.aantallenInAanvraagType | lowercase }}
                                        </span>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label for="Artikel" class="col-sm-5 col-form-label">Artikel</label>
                                    <div class="col-sm-7">
                                        <span id="Artikel"
                                              class="form-control-plaintext">{{ details.hamiplantArtikelNr }}</span>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label for="Potmaat" class="col-sm-5 col-form-label">Potmaat</label>
                                    <div class="col-sm-7">
                                        <span id="Potmaat"
                                              class="form-control-plaintext">{{ details.leverancierDetails.potmaat || details.potmaat }}</span>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label for="Hoogte" class="col-sm-5 col-form-label">Hoogte</label>
                                    <div class="col-sm-7">
                                        <mat-form-field id="Hoogte" *ngIf="!isDisabled; else elseBlock2">
                                            <input #heightInput type="text" aria-label="Hoogte" matInput
                                                   [formControl]="heightControl" [matAutocomplete]="auto">
                                            <span matSuffix *ngIf="heightControl.invalid">
                                                &nbsp; <i class="fa-solid fa-exclamation"
                                                          style="color: red;"></i>
                                            </span>
                                            <mat-autocomplete #auto="matAutocomplete">
                                                <mat-option (onSelectionChange)="heightInput.value != undefined && onEnter($event)"
                                                            *ngFor="let option of filteredHeights | async"
                                                            [value]="option.featureValue | fromVbnS02">
                                                    {{ option.description }}
                                                </mat-option>
                                            </mat-autocomplete>
                                        </mat-form-field>
                                        <ng-template #elseBlock2>
                                            <span class="form-control-plaintext">
                                                {{
                                            details.leverancierDetails.hoogte
                                                }}
                                            </span>
                                        </ng-template>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label for="AanvullendeKenmerken" class="col-sm-5 col-form-label">
                                        Aanvullende
                                        kenmerken
                                    </label>
                                    <div class="col-sm-7">
                                        <div class="row" *ngIf="!isDisabled">
                                            <div class="col-sm-10">
                                                <mat-form-field id="AanvullendeKenmerken" *ngIf="false">
                                                    <input #featureTypeInput type="text" aria-label="Kenmerktype"
                                                           matInput [formControl]="featureTypeControl"
                                                           [matAutocomplete]="auto">
                                                    <!--<span matSuffix *ngIf="featureTypeControl.invalid">
                            &nbsp; <i class="fa-solid fa-exclamation"
                                      style="color: red;"></i>
                        </span>-->
                                                    <mat-autocomplete #auto="matAutocomplete">
                                                        <mat-option (onSelectionChange)="featureTypeInput.value != undefined && onEnterFeatureType($event)"
                                                                    *ngFor="let option of filteredFeatureTypes | async"
                                                                    [value]="option.id">
                                                            {{ option.label }}
                                                        </mat-option>
                                                    </mat-autocomplete>
                                                </mat-form-field>
                                            </div>
                                            <div class="col-sm-10" *ngIf="selectedFeatureType">
                                                <mat-form-field *ngIf="!isDisabled">
                                                    <input #featureValueInput type="text" aria-label="Kenmerkwaarde"
                                                           matInput [formControl]="featureValueControl"
                                                           [matAutocomplete]="auto">
                                                    <!--<span matSuffix *ngIf="featureValueControl.invalid">
                            &nbsp; <i class="fa-solid fa-exclamation"
                                      style="color: red;"></i>
                        </span>-->
                                                    <mat-autocomplete #auto="matAutocomplete">
                                                        <mat-option (onSelectionChange)="featureValueInput.value != undefined && onEnterFeatureValue($event)"
                                                                    *ngFor="let option of filteredFeatureValues | async"
                                                                    [value]="option.featureValue">
                                                            {{ option.label }}
                                                        </mat-option>
                                                    </mat-autocomplete>
                                                </mat-form-field>
                                            </div>
                                            <button *ngIf="selectedFeatureType || selectedFeatureValue != undefined"
                                                    mat-raised-button color="primary"
                                                    [disabled]="!selectedFeatureType || !selectedFeatureValue"
                                                    (click)="onAddFeature()">
                                                Opslaan
                                            </button>
                                        </div>
                                        <ng-container *ngFor="let feature of details.features">
                                            <span class="form-control-plaintext">
                                                <span class="text-danger" style="cursor: pointer;" *ngIf="false">
                                                    <i class="fa-solid fa-trash"
                                                       (click)="onDeleteFeature(feature)"></i>
                                                </span> {{ feature.label }}
                                            </span>
                                        </ng-container>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label for="OpmerkingInkoop" class="col-sm-5 col-form-label">
                                        Opmerking
                                        inkoop
                                    </label>
                                    <div class="col-sm-7">
                                        <mat-form-field id="OpmerkingInkoop" *ngIf="false; else elseBlock3">
                                            <textarea matInput maxlength="250" [(ngModel)]="details.leverancierDetails.opmerkingInkoop"></textarea>
                                        </mat-form-field>
                                        <ng-template #elseBlock3>
                                            <span class="form-control-plaintext">
                                                {{
                                            details.leverancierDetails.opmerkingInkoop
                                                }}
                                            </span>
                                        </ng-template>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label for="OpmerkingLeverancier" class="col-sm-5 col-form-label">
                                        Opmerking
                                        leverancier
                                    </label>
                                    <div class="col-sm-7">
                                        <mat-form-field id="OpmerkingLeverancier" *ngIf="!isDisabled; else elseBlock4">
                                            <textarea matInput maxlength="250"
                                                      [(ngModel)]="details.leverancierDetails.opmerkingLeverancier"></textarea>
                                        </mat-form-field>
                                        <ng-template #elseBlock4>
                                            <span class="form-control-plaintext">
                                                {{
                                            details.leverancierDetails.opmerkingLeverancier
                                                }}
                                            </span>
                                        </ng-template>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label for="KwekerGTIN" class="col-sm-5 col-form-label">Kweker EAN</label>
                                    <div class="col-sm-7">
                                        <span id="KwekerGTIN"
                                              class="form-control-plaintext">{{ details.kwekerGTIN || details.kwekerEan }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-8">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="card">
                                <div class="card-header">
                                    Logistiek
                                </div>
                                <div class="card-body">
                                    <div class="card-text">
                                        <div class="form-group row"
                                             *ngIf="(details.ladingdragerType1 | containsstring: 'pallet') || (details.ladingdragerType2 | containsstring: 'pallet') || (details.ladingdragerType3 | containsstring: 'pallet')">
                                            <label for="Dooshoogte" class="col-sm-5 col-form-label">Dooshoogte</label>
                                            <div class="col-sm-7">
                                                <mat-form-field id="Dooshoogte" *ngIf="!isDisabled; else elseBlock14">
                                                    <!--<input type="number" matInput [(ngModel)]="details.leverancierDetails.dooshoogte">-->
                                                    <mat-select (selectionChange)="onChangeDooshoogte($event)"
                                                                [(ngModel)]="details.leverancierDetails.dooshoogte">
                                                        <mat-option></mat-option>
                                                        <mat-option *ngFor="let option of dooshoogtes"
                                                                    [value]="option">
                                                            {{ option }}cm
                                                        </mat-option>
                                                    </mat-select>
                                                    <span matSuffix *ngIf="details.leverancierDetails.dooshoogte == null">
                                                        &nbsp; <i class="fa-solid fa-exclamation"
                                                                  style="color: red;"></i>
                                                    </span>
                                                </mat-form-field>
                                                <ng-template #elseBlock14>
                                                    <span class="form-control-plaintext">
                                                        {{
                                                    details.leverancierDetails.dooshoogte
                                                        | number : '1.0-0'
                                                        }}
                                                    </span>
                                                </ng-template>
                                            </div>
                                        </div>

                                        <div class="form-group row"
                                             *ngIf="(details.ladingdragerType1 | containsstring: 'pallet') || (details.ladingdragerType2 | containsstring: 'pallet') || (details.ladingdragerType3 | containsstring: 'pallet')">
                                            <label for="LevertEigenDozen" class="col-sm-5 col-form-label">
                                                Levert eigen
                                                dozen
                                            </label>
                                            <div class="col-sm-7">
                                                <mat-checkbox id="LevertEigenDozen" [(ngModel)]="details.levertEigenDozen"
                                                              *ngIf="false; else elseBlock34"></mat-checkbox>
                                                <ng-template #elseBlock34>
                                                    <span class="form-control-plaintext">
                                                        {{
                                                    details.levertEigenDozen | yesno
                                                        }}
                                                    </span>
                                                </ng-template>
                                            </div>
                                        </div>

                                        <div *ngIf="!(details.ladingdragerType1 | isnullorempty)">
                                            <div class="font-weight-bold kp-heading">
                                                Ladingdrager
                                                1: {{ details.ladingdragerType1 }}
                                            </div>

                                            <span class="text-danger" *ngIf="showBeladingValidationMessage">De belading moet volledig ingevuld zijn. Vul de velden aan.</span>

                                            <div class="form-group row">
                                                <label for="FustNr1" class="col-sm-5 col-form-label">Fust</label>
                                                <div class="col-sm-7">
                                                    <mat-form-field id="FustNr1" *ngIf="!isDisabled; else elseBlock15">
                                                        <input #fustNr1Input
                                                               type="text"
                                                               aria-label="Fust"
                                                               matInput
                                                               [formControl]="fustNr1Control"
                                                               [(ngModel)]="details.leverancierDetails.fustNr1"
                                                               [matAutocomplete]="fustAuto1"
                                                               (selectionChange)="onChangeFustNr()">
                                                        <mat-autocomplete #fustAuto1="matAutocomplete" [displayWith]="displayFustFn.bind(this)">
                                                            <mat-option *ngFor="let fust of filteredFusten1 | async"
                                                                        [value]="fust.id"
                                                                        [matTooltip]="fust.id + '. ' + fust.naam + ' (' + fust.alfa + ')'">
                                                                <span>{{ fust.id }}. {{ fust.naam }}</span>
                                                                <small *ngIf="!(fust.alfa | isnullorempty)">
                                                                    ({{ fust.alfa }})
                                                                </small>
                                                            </mat-option>
                                                        </mat-autocomplete>
                                                        <span matSuffix *ngIf="details.leverancierDetails.fustNr1 == null">
                                                            &nbsp; <i class="fa-solid fa-exclamation"
                                                                      style="color: red;"></i>
                                                        </span>
                                                    </mat-form-field>
                                                    <ng-template #elseBlock15>
                                                        <span class="form-control-plaintext">
                                                            {{
                                                        displayFn(selectedFust1)
                                                            }}
                                                        </span>
                                                    </ng-template>
                                                </div>
                                            </div>

                                            <div class="form-group row">
                                                <label for="Belading1" class="col-sm-5 col-form-label">
                                                    Belading
                                                    <span matSuffix *ngIf="showBeladingValidationMessage">
                                                        &nbsp; <i class="fa-solid fa-exclamation"
                                                                  style="color: red;"></i>
                                                    </span>
                                                </label>
                                                <div class="col-sm-7">
                                                    <mat-form-field class="belading" id="Belading1" appearance="fill"
                                                                    *ngIf="!isDisabled; else elseBlock16">
                                                        <input type="number" matInput
                                                               [(ngModel)]="details.leverancierDetails.aantalLagenPerLadingdrager1">
                                                    </mat-form-field>
                                                    <span *ngIf="!isDisabled">x</span>
                                                    <mat-form-field class="belading" appearance="fill" *ngIf="!isDisabled;">
                                                        <input type="number" matInput
                                                               [(ngModel)]="details.leverancierDetails.fustenPerLaag1">
                                                    </mat-form-field>
                                                    <span *ngIf="!isDisabled">x</span>
                                                    <mat-form-field class="belading" appearance="fill" *ngIf="!isDisabled;">
                                                        <input type="number" matInput
                                                               [(ngModel)]="details.leverancierDetails.stuks1">
                                                    </mat-form-field>
                                                    <ng-template #elseBlock16>
                                                        <span class="form-control-plaintext">
                                                            {{
                                                        details.leverancierDetails.aantalLagenPerLadingdrager1
                                                            }}x{{
                                                        details.leverancierDetails.fustenPerLaag1
                                                            }}x{{ details.leverancierDetails.stuks1 }}
                                                        </span>
                                                    </ng-template>
                                                    <span style="font-size: small;"><code>Lagen/drager</code> x <code>Fusten/laag</code> x <code>Inhoud/fust</code></span>
                                                </div>
                                            </div>

                                            <div class="form-group row">
                                                <label for="MaxHoogteLadingdrager1" class="col-sm-5 col-form-label">
                                                    Maximale
                                                    hoogte
                                                </label>
                                                <div class="col-sm-7">
                                                    <mat-form-field id="MaxHoogteLadingdrager1" *ngIf="false; else elseBlock20">
                                                        <input type="number" matInput
                                                               [(ngModel)]="details.leverancierDetails.maxHoogteLadingdrager1">
                                                    </mat-form-field>
                                                    <ng-template #elseBlock20>
                                                        <span class="form-control-plaintext">
                                                            {{
                                                        details.leverancierDetails.maxHoogteLadingdrager1
                                                            }}
                                                        </span>
                                                    </ng-template>
                                                </div>
                                            </div>
                                        </div>

                                        <div *ngIf="!(details.ladingdragerType2 | isnullorempty)">
                                            <div class="font-weight-bold kp-heading">
                                                Ladingdrager
                                                2: {{ details.ladingdragerType2 }}
                                            </div>

                                            <div class="form-group row">
                                                <label for="FustNr2" class="col-sm-5 col-form-label">Fust</label>
                                                <div class="col-sm-7">
                                                    <mat-form-field id="FustNr2" *ngIf="!isDisabled; else elseBlock21">
                                                        <input #fustNr2Input
                                                               type="text"
                                                               aria-label="Fust"
                                                               matInput
                                                               [formControl]="fustNr2Control"
                                                               [(ngModel)]="details.leverancierDetails.fustNr2"
                                                               [matAutocomplete]="fustAuto2"
                                                               (selectionChange)="onChangeFustNr()">
                                                        <mat-autocomplete #fustAuto2="matAutocomplete" [displayWith]="displayFustFn.bind(this)">
                                                            <mat-option *ngFor="let fust of filteredFusten2 | async"
                                                                        [value]="fust.id"
                                                                        [matTooltip]="fust.id + '. ' + fust.naam + ' (' + fust.alfa + ')'">
                                                                <span>{{ fust.id }}. {{ fust.naam }}</span>
                                                                <small *ngIf="!(fust.alfa | isnullorempty)">
                                                                    ({{ fust.alfa }})
                                                                </small>
                                                            </mat-option>
                                                        </mat-autocomplete>
                                                        <span matSuffix *ngIf="details.leverancierDetails.fustNr2 == null">
                                                            &nbsp; <i class="fa-solid fa-exclamation"
                                                                      style="color: red;"></i>
                                                        </span>
                                                    </mat-form-field>
                                                    <ng-template #elseBlock21>
                                                        <span class="form-control-plaintext">
                                                            {{
                                                        displayFn(selectedFust2)
                                                            }}
                                                        </span>
                                                    </ng-template>
                                                </div>
                                            </div>

                                            <div class="form-group row">
                                                <label for="Belading2" class="col-sm-5 col-form-label">Belading</label>
                                                <div class="col-sm-7">
                                                    <mat-form-field class="belading" id="Belading2" appearance="fill"
                                                                    *ngIf="!isDisabled; else elseBlock22">
                                                        <input type="number" matInput
                                                               [(ngModel)]="details.leverancierDetails.aantalLagenPerLadingdrager2">
                                                    </mat-form-field>
                                                    <span *ngIf="!isDisabled">x</span>
                                                    <mat-form-field class="belading" appearance="fill" *ngIf="!isDisabled;">
                                                        <input type="number" matInput
                                                               [(ngModel)]="details.leverancierDetails.fustenPerLaag2">
                                                    </mat-form-field>
                                                    <span *ngIf="!isDisabled">x</span>
                                                    <mat-form-field class="belading" appearance="fill" *ngIf="!isDisabled;">
                                                        <input type="number" matInput
                                                               [(ngModel)]="details.leverancierDetails.stuks2">
                                                    </mat-form-field>
                                                    <ng-template #elseBlock22>
                                                        <span class="form-control-plaintext">
                                                            {{
                                                        details.leverancierDetails.aantalLagenPerLadingdrager2
                                                            }}x{{
                                                        details.leverancierDetails.fustenPerLaag2
                                                            }}x{{ details.leverancierDetails.stuks2 }}
                                                        </span>
                                                    </ng-template>
                                                    <span style="font-size: small;"><code>Lagen/drager</code> x <code>Fusten/laag</code> x <code>Inhoud/fust</code></span>
                                                </div>
                                            </div>

                                            <div class="form-group row">
                                                <label for="MaxHoogteLadingdrager2" class="col-sm-5 col-form-label">
                                                    Maximale
                                                    hoogte
                                                </label>
                                                <div class="col-sm-7">
                                                    <mat-form-field id="MaxHoogteLadingdrager2" *ngIf="false; else elseBlock26">
                                                        <input type="number" matInput
                                                               [(ngModel)]="details.leverancierDetails.maxHoogteLadingdrager2">
                                                    </mat-form-field>
                                                    <ng-template #elseBlock26>
                                                        <span class="form-control-plaintext">
                                                            {{
                                                        details.leverancierDetails.maxHoogteLadingdrager2
                                                            }}
                                                        </span>
                                                    </ng-template>
                                                </div>
                                            </div>
                                        </div>

                                        <div *ngIf="!(details.ladingdragerType3 | isnullorempty)">
                                            <div class="font-weight-bold kp-heading">
                                                Ladingdrager
                                                3: {{ details.ladingdragerType3 }}
                                            </div>

                                            <div class="form-group row">
                                                <label for="FustNr3" class="col-sm-5 col-form-label">Fust</label>
                                                <div class="col-sm-7">
                                                    <mat-form-field id="FustNr3" *ngIf="!isDisabled; else elseBlock27">
                                                        <input #fustNr3Input
                                                               type="text"
                                                               aria-label="Fust"
                                                               matInput
                                                               [formControl]="fustNr3Control"
                                                               [(ngModel)]="details.leverancierDetails.fustNr3"
                                                               [matAutocomplete]="fustAuto3"
                                                               (selectionChange)="onChangeFustNr()">
                                                        <mat-autocomplete #fustAuto3="matAutocomplete" [displayWith]="displayFustFn.bind(this)">
                                                            <mat-option *ngFor="let fust of filteredFusten3 | async"
                                                                        [value]="fust.id"
                                                                        [matTooltip]="fust.id + '. ' + fust.naam + ' (' + fust.alfa + ')'">
                                                                <span>{{ fust.id }}. {{ fust.naam }}</span>
                                                                <small *ngIf="!(fust.alfa | isnullorempty)">
                                                                    ({{ fust.alfa }})
                                                                </small>
                                                            </mat-option>
                                                        </mat-autocomplete>
                                                        <span matSuffix *ngIf="details.leverancierDetails.fustNr3 == null">
                                                            &nbsp; <i class="fa-solid fa-exclamation"
                                                                      style="color: red;"></i>
                                                        </span>
                                                    </mat-form-field>
                                                    <ng-template #elseBlock27>
                                                        <span class="form-control-plaintext">
                                                            {{
                                                        displayFn(selectedFust3)
                                                            }}
                                                        </span>
                                                    </ng-template>
                                                </div>
                                            </div>

                                            <div class="form-group row">
                                                <label for="Belading3" class="col-sm-5 col-form-label">Belading</label>
                                                <div class="col-sm-7">
                                                    <mat-form-field class="belading" id="Belading3" appearance="fill"
                                                                    *ngIf="!isDisabled; else elseBlock28">
                                                        <input type="number" matInput
                                                               [(ngModel)]="details.leverancierDetails.aantalLagenPerLadingdrager3">
                                                    </mat-form-field>
                                                    <span *ngIf="!isDisabled">x</span>
                                                    <mat-form-field class="belading" appearance="fill" *ngIf="!isDisabled;">
                                                        <input type="number" matInput
                                                               [(ngModel)]="details.leverancierDetails.fustenPerLaag3">
                                                    </mat-form-field>
                                                    <span *ngIf="!isDisabled">x</span>
                                                    <mat-form-field class="belading" appearance="fill" *ngIf="!isDisabled;">
                                                        <input type="number" matInput
                                                               [(ngModel)]="details.leverancierDetails.stuks3">
                                                    </mat-form-field>
                                                    <ng-template #elseBlock28>
                                                        <span class="form-control-plaintext">
                                                            {{
                                                        details.leverancierDetails.aantalLagenPerLadingdrager3
                                                            }}x{{
                                                        details.leverancierDetails.fustenPerLaag3
                                                            }}x{{ details.leverancierDetails.stuks3 }}
                                                        </span>
                                                    </ng-template>
                                                    <span style="font-size: small;"><code>Lagen/drager</code> x <code>Fusten/laag</code> x <code>Inhoud/fust</code></span>
                                                </div>
                                            </div>

                                            <div class="form-group row">
                                                <label for="MaxHoogteLadingdrager3" class="col-sm-5 col-form-label">
                                                    Maximale
                                                    hoogte
                                                </label>
                                                <div class="col-sm-7">
                                                    <mat-form-field id="MaxHoogteLadingdrager3" *ngIf="false; else elseBlock32">
                                                        <input type="number" matInput
                                                               [(ngModel)]="details.leverancierDetails.maxHoogteLadingdrager3">
                                                    </mat-form-field>
                                                    <ng-template #elseBlock32>
                                                        <span class="form-control-plaintext">
                                                            {{
                                                        details.leverancierDetails.maxHoogteLadingdrager3
                                                            }}
                                                        </span>
                                                    </ng-template>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Prijzen (enkel vaste prijzen) -->
                        <div class="col-sm-12" *ngIf="!details.prijsperiodeAndStaffelsEnabled || (!details.hasTieredPricing && !details.hasPurchasePricePeriods)">
                            <div class="card">
                                <div class="card-header">
                                    <span>Prijzen</span>
                                </div>
                                <div class="card-body">
                                    <div class="card-text">
                                    <ng-template [ngIf]="details.isSticker && !(details && details.prijsperiodeAndStaffelsEnabled && (details.hasTieredPricing || details.hasPurchasePricePeriods))">
                                <div class="form-group row">
                                    <label for="InclusiefSticker" class="col-sm-5 col-form-label">
                                        Inclusief sticker
                                    </label>
                                    <div class="col-sm-7">
                                        <mat-checkbox id="InclusiefSticker"
                                                      [(ngModel)]="details.leverancierDetails.isInclusiefSticker"
                                                      *ngIf="!isDisabled; else elseBlock10"></mat-checkbox>
                                        <ng-template #elseBlock10>
                                            <span class="form-control-plaintext">
                                                {{
                                            details.leverancierDetails.isInclusiefSticker | yesno
                                                }}
                                            </span>
                                        </ng-template>
                                    </div>
                                </div>

                                <ng-template [ngIf]="!details.leverancierDetails.isInclusiefSticker">

                                    <div class="form-group row"
                                         *ngIf="!(details.locatieProductlabelCode1 | isnullorempty)">
                                        <label for="Stickerprijs1" class="col-sm-5 col-form-label">
                                            Stickerprijs {{
                                                details.locatieProductlabelCode1
                                            }}
                                        </label>
                                        <div class="col-sm-7">
                                            <mat-form-field id="Stickerprijs1"
                                                            *ngIf="!isDisabled; else elseBlock11">
                                                <input currencyMask matInput
                                                       [(ngModel)]="details.leverancierDetails.stickerprijs1">
                                            </mat-form-field>
                                            <ng-template #elseBlock11>
                                                <span class="form-control-plaintext">
                                                    {{
                                                details.leverancierDetails.stickerprijs1
                                                    }}
                                                </span>
                                            </ng-template>
                                        </div>
                                    </div>

                                    <div class="form-group row"
                                         *ngIf="!(details.locatieProductlabelCode2 | isnullorempty)">
                                        <label for="Stickerprijs2" class="col-sm-5 col-form-label">
                                            Stickerprijs {{
                                                details.locatieProductlabelCode2
                                            }}
                                        </label>
                                        <div class="col-sm-7">
                                            <mat-form-field id="Stickerprijs2"
                                                            *ngIf="!isDisabled; else elseBlock12">
                                                <input currencyMask matInput
                                                       [(ngModel)]="details.leverancierDetails.stickerprijs2">
                                            </mat-form-field>
                                            <ng-template #elseBlock12>
                                                <span class="form-control-plaintext">
                                                    {{
                                                details.leverancierDetails.stickerprijs2
                                                    }}
                                                </span>
                                            </ng-template>
                                        </div>
                                    </div>

                                    <div class="form-group row"
                                         *ngIf="!(details.locatieProductlabelCode3 | isnullorempty)">
                                        <label for="Stickerprijs3" class="col-sm-5 col-form-label">
                                            Stickerprijs {{
                                                details.locatieProductlabelCode3
                                            }}
                                        </label>
                                        <div class="col-sm-7">
                                            <mat-form-field id="Stickerprijs3"
                                                            *ngIf="!isDisabled; else elseBlock13">
                                                <input currencyMask matInput
                                                       [(ngModel)]="details.leverancierDetails.stickerprijs3">
                                            </mat-form-field>
                                            <ng-template #elseBlock13>
                                                <span class="form-control-plaintext">
                                                    {{
                                                details.leverancierDetails.stickerprijs3
                                                    }}
                                                </span>
                                            </ng-template>
                                        </div>
                                    </div>
                                </ng-template>
                            </ng-template>
                                        <div class="form-group row" *ngIf="details.showPrijsAftuin">
                                            <label for="ActualPriceAftuin" class="col-sm-5 col-form-label">Prijs Aftuin</label>
                                            <div class="col-sm-7">
                                                <mat-form-field id="ActualPriceAftuin" *ngIf="!isDisabled; else elseBlockPrijsAftuin">
                                                    <input currencyMask matInput [formControl]="actualPriceAftuinControl" [disabled]="!hasPersistedDefaultPrijsRegel" (blur)="onFixedPrijsBlur('actualPriceAftuin')">
                                                    <span matSuffix *ngIf="actualPriceAftuinControl.invalid">
                                                &nbsp; <i class="fa-solid fa-exclamation" style="color: red;"></i>
                                            </span>
                                                </mat-form-field>
                                                <ng-template #elseBlockPrijsAftuin>
                                                    <span class="form-control-plaintext">{{ defaultPrijsRegel?.actualPriceAftuin ?? '-' }}</span>
                                                </ng-template>
                                            </div>
                                        </div>

                                        <div class="form-group row" *ngIf="details.showPrijsHamiplantGeleverd">
                                            <label for="ActualPriceBox" class="col-sm-5 col-form-label">Prijs Hamiplant geleverd</label>
                                            <div class="col-sm-7">
                                                <mat-form-field id="ActualPriceBox" *ngIf="!isDisabled; else elseBlockPrijsHPL">
                                                    <input currencyMask matInput [formControl]="actualPriceBoxControl" [disabled]="!hasPersistedDefaultPrijsRegel" (blur)="onFixedPrijsBlur('actualPriceBox')">
                                                    <span matSuffix *ngIf="actualPriceBoxControl.invalid">
                                                &nbsp; <i class="fa-solid fa-exclamation" style="color: red;"></i>
                                            </span>
                                                </mat-form-field>
                                                <ng-template #elseBlockPrijsHPL>
                                                    <span class="form-control-plaintext">{{ defaultPrijsRegel?.actualPriceBox ?? '-' }}</span>
                                                </ng-template>
                                            </div>
                                        </div>
                                        <div class="form-group row" *ngIf="!isDisabled && !hasPersistedDefaultPrijsRegel">
                                            <div class="col-sm-12">
                                                <span class="text-warning">
                                                    Standaard prijsregel ontbreekt nog in synchronisatie. Prijsvelden zijn tijdelijk alleen-lezen; probeer later opnieuw.
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Prijsperiodes en Staffels -->
                <div class="col-sm-12" *ngIf="details.prijsperiodeAndStaffelsEnabled && (details.hasTieredPricing || details.hasPurchasePricePeriods)">
                    <div class="card">
                        <div class="card-header d-flex align-items-center justify-content-between">
                            <span>Prijsperiodes en/of -Staffels</span>
                            <span class="ml-auto d-flex align-items-center">
                                <!-- Eén groene plus knop die een regel toevoegt obv bestaande ngIf condities -->
                                <button type="button" class="btn btn-link p-0"
                                        *ngIf="(details.hasPurchasePricePeriods || details.hasTieredPricing) && !isDisabled"
                                        (click)="addEmptyPrijsRegelAuto()"
                                        [disabled]="isMaxPrijsRegelsReached"
                                        [title]="isMaxPrijsRegelsReached ? 'Maximaal 6 prijsregels mogelijk' : 'Nieuwe prijsregel toevoegen'">
                                    <i class="fa-solid fa-circle-plus fa-2x" style="color: #1aa251;"></i>
                                </button>
                                <small *ngIf="isMaxPrijsRegelsReached" class="text-muted ml-2">Maximaal 6 prijsregels mogelijk</small>
                            </span>
                        </div>
                        <div class="card-body">
                            <div class="card-text">
                                <div *ngIf="details && details.prijsperiodeAndStaffelsEnabled && (details.hasTieredPricing || details.hasPurchasePricePeriods); else noPrijsRegelsInfo">
                                    <ng-template [ngIf]="details.isSticker">
                                        <div class="form-group row">
                                            <label for="InclusiefSticker" class="col-sm-5 col-form-label">
                                                Inclusief sticker
                                            </label>
                                            <div class="col-sm-7">
                                                <mat-checkbox id="InclusiefSticker"
                                                              [(ngModel)]="details.leverancierDetails.isInclusiefSticker"
                                                              *ngIf="!isDisabled; else elseBlock10"></mat-checkbox>
                                                <ng-template #elseBlock10>
                                                    <span class="form-control-plaintext">
                                                        {{
                                                            details.leverancierDetails.isInclusiefSticker | yesno
                                                        }}
                                                    </span>
                                                </ng-template>
                                            </div>
                                        </div>

                                        <ng-template [ngIf]="!details.leverancierDetails.isInclusiefSticker">

                                            <div class="form-group row"
                                                 *ngIf="!(details.locatieProductlabelCode1 | isnullorempty)">
                                                <label for="Stickerprijs1" class="col-sm-5 col-form-label">
                                                    Stickerprijs {{
                                                        details.locatieProductlabelCode1
                                                    }}
                                                </label>
                                                <div class="col-sm-7">
                                                    <mat-form-field id="Stickerprijs1"
                                                                    *ngIf="!isDisabled; else elseBlock11">
                                                        <input currencyMask matInput
                                                               [(ngModel)]="details.leverancierDetails.stickerprijs1">
                                                    </mat-form-field>
                                                    <ng-template #elseBlock11>
                                                        <span class="form-control-plaintext">
                                                            {{
                                                                details.leverancierDetails.stickerprijs1
                                                            }}
                                                        </span>
                                                    </ng-template>
                                                </div>
                                            </div>

                                            <div class="form-group row"
                                                 *ngIf="!(details.locatieProductlabelCode2 | isnullorempty)">
                                                <label for="Stickerprijs2" class="col-sm-5 col-form-label">
                                                    Stickerprijs {{
                                                        details.locatieProductlabelCode2
                                                    }}
                                                </label>
                                                <div class="col-sm-7">
                                                    <mat-form-field id="Stickerprijs2"
                                                                    *ngIf="!isDisabled; else elseBlock12">
                                                        <input currencyMask matInput
                                                               [(ngModel)]="details.leverancierDetails.stickerprijs2">
                                                    </mat-form-field>
                                                    <ng-template #elseBlock12>
                                                        <span class="form-control-plaintext">
                                                            {{
                                                                details.leverancierDetails.stickerprijs2
                                                            }}
                                                        </span>
                                                    </ng-template>
                                                </div>
                                            </div>

                                            <div class="form-group row"
                                                 *ngIf="!(details.locatieProductlabelCode3 | isnullorempty)">
                                                <label for="Stickerprijs3" class="col-sm-5 col-form-label">
                                                    Stickerprijs {{
                                                        details.locatieProductlabelCode3
                                                    }}
                                                </label>
                                                <div class="col-sm-7">
                                                    <mat-form-field id="Stickerprijs3"
                                                                    *ngIf="!isDisabled; else elseBlock13">
                                                        <input currencyMask matInput
                                                               [(ngModel)]="details.leverancierDetails.stickerprijs3">
                                                    </mat-form-field>
                                                    <ng-template #elseBlock13>
                                                        <span class="form-control-plaintext">
                                                            {{
                                                                details.leverancierDetails.stickerprijs3
                                                            }}
                                                        </span>
                                                    </ng-template>
                                                </div>
                                            </div>
                                        </ng-template>
                                    </ng-template>
                                    <div class="row d-none d-md-flex text-muted font-weight-bold">
                                        <div class="col-md-3" *ngIf="details.hasPurchasePricePeriods">Periode van</div>
                                        <div class="col-md-3" *ngIf="details.hasPurchasePricePeriods">Periode tot</div>
                                        <div class="col-md-2" *ngIf="details.hasTieredPricing">Aantal {{ details.aantallenInAanvraagType | lowercase }}</div>
                                        <div class="col-md-2" *ngIf="details.showPrijsAftuin">Aftuin prijs</div>
                                        <div class="col-md-2" *ngIf="details.showPrijsHamiplantGeleverd">HPL prijs</div>
                                    </div>

                                    <!-- Rows -->
                                    <div *ngFor="let p of details.prijsRegels"
                                         class="row align-items-center prijsregel-row position-relative">
                                        <!-- Periode van -->
                                        <div class="col-md-3" *ngIf="details.hasPurchasePricePeriods">
                                            <div class="d-md-none text-muted small">Periode van</div>
                                            <ng-container *ngIf="p.softwareSource === SoftwareSource.KwekerPortaal; else fromReadonly">
                                                <mat-form-field class="w-100">
                                                    <input matInput [matDatepicker]="fromPicker" [disabled]="isDisabled"
                                                           [(ngModel)]="p.periodFrom"
                                                           (dateChange)="onKwekerPortaalRegelBlur(p)">
                                                    <mat-datepicker-toggle matSuffix
                                                                           [for]="fromPicker"></mat-datepicker-toggle>
                                                    <mat-datepicker #fromPicker></mat-datepicker>
                                                </mat-form-field>
                                            </ng-container>
                                            <ng-template #fromReadonly>
                                                <span class="form-control-plaintext">{{ p.periodFrom | date: 'dd-MM-yyyy' }}</span>
                                            </ng-template>
                                        </div>

                                        <!-- Periode tot -->
                                        <div class="col-md-3" *ngIf="details.hasPurchasePricePeriods">
                                            <div class="d-md-none text-muted small">Periode tot</div>
                                            <ng-container *ngIf="p.softwareSource === SoftwareSource.KwekerPortaal; else toReadonly">
                                                <mat-form-field class="w-100">
                                                    <input matInput [matDatepicker]="toPicker" [disabled]="isDisabled"
                                                           [(ngModel)]="p.periodTo"
                                                           (dateChange)="onKwekerPortaalRegelBlur(p)">
                                                    <mat-datepicker-toggle matSuffix
                                                                           [for]="toPicker"></mat-datepicker-toggle>
                                                    <mat-datepicker #toPicker></mat-datepicker>
                                                </mat-form-field>
                                            </ng-container>
                                            <ng-template #toReadonly>
                                                <span class="form-control-plaintext">{{ p.periodTo | date: 'dd-MM-yyyy' }}</span>
                                            </ng-template>
                                        </div>

                                        <!-- Staffel aantal -->
                                        <div class="col-md-2" *ngIf="details.hasTieredPricing">
                                            <div class="d-md-none text-muted small">Aantal {{ details.aantallenInAanvraagType | lowercase }}</div>
                                            <ng-container *ngIf="p.softwareSource === SoftwareSource.KwekerPortaal; else tierReadonly">
                                                <input type="number" min="1" class="form-control text-right"
                                                       [disabled]="isDisabled"
                                                       [(ngModel)]="p.tierQuantity"
                                                       (blur)="onKwekerPortaalRegelBlur(p)">
                                            </ng-container>
                                            <ng-template #tierReadonly>
                                                <span class="form-control-plaintext">{{ p.tierQuantity }}</span>
                                            </ng-template>
                                        </div>

                                        <!-- Werkelijke prijs aftuin (editable) -->
                                        <div class="col-md-2" *ngIf="details.showPrijsAftuin">
                                            <div class="d-md-none text-muted small">Werkelijke prijs aftuin</div>
                                            <mat-form-field class="w-100">
                                                <input currencyMask matInput class="text-right"
                                                       [disabled]="isDisabled"
                                                       [(ngModel)]="p.actualPriceAftuin"
                                                       (blur)="onPrijsRegelBlur(p, 'actualPriceAftuin')">
                                                <span matSuffix
                                                      *ngIf="!isDisabled && (p.actualPriceAftuin === null || p.actualPriceAftuin === undefined)">
                                                    &nbsp; <i class="fa-solid fa-exclamation" style="color: red;"></i>
                                                </span>
                                            </mat-form-field>
                                        </div>

                                        <!-- Werkelijke hamiplant geleverd prijs -->
                                        <div class="col-md-2" *ngIf="details.showPrijsHamiplantGeleverd">
                                            <div class="d-md-none text-muted small">Werkelijke prijs per doos</div>
                                            <mat-form-field class="w-100">
                                                <input currencyMask matInput class="text-right"
                                                       [disabled]="isDisabled"
                                                       [(ngModel)]="p.actualPriceBox"
                                                       (blur)="onPrijsRegelBlur(p, 'actualPriceBox')">
                                                <span matSuffix
                                                      *ngIf="!isDisabled && (p.actualPriceBox === null || p.actualPriceBox === undefined)">
                                                    &nbsp; <i class="fa-solid fa-exclamation" style="color: red;"></i>
                                                </span>
                                            </mat-form-field>
                                        </div>

                                        <!-- Delete icon for KwekerPortaal rows (floating on the right) -->
                                        <button type="button"
                                                class="btn btn-link p-0 prijsregel-delete"
                                                *ngIf="p.softwareSource === SoftwareSource.KwekerPortaal"
                                                [disabled]="isDisabled || details.prijsRegels.length === 1"
                                                title="Verwijderen"
                                                aria-label="Verwijderen"
                                                (click)="deletePrijsRegel(p)">
                                            <i class="fa-solid fa-trash" style="color: #d9534f;"></i>
                                        </button>
                                    </div>
                                </div>
                                <ng-template #noPrijsRegelsInfo>
                                    <div class="text-muted">Geen prijsperiodes en/of staffels van toepassing.</div>
                                </ng-template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-raised-button color="warn" mat-dialog-close>Annuleren</button>
    <button mat-raised-button (click)="openNewAanvraagRegel(details.id)" *ngIf="!isLoadingDetails && !isAlternativeItem"
            [disabled]="isDisabled || heightControl.invalid">
        Alternatief aanbieden
    </button>
    <button mat-raised-button color="accent" (click)="saveRegelDetails(LeverancierStatus.NietLeverbaarUitverkocht)"
            [disabled]="isDisabled" *ngIf="!isLoadingDetails && !isAlternativeItem">
        Niet leverbaar
    </button>
    <button mat-raised-button [class.mat-primary-2]="!(isDisabled || heightControl.invalid)"
            (click)="saveRegelDetails(LeverancierStatus.Voltooid)" [disabled]="isDisabled || heightControl.invalid"
            *ngIf="!isLoadingDetails">
        Markeer als gereed
        <span matSuffix *ngIf="isButtonDisabled" title="Nog niet alle velden zijn juist ingevuld. Vul aan waar nodig.">
            <i class="fa-solid fa-exclamation"
               style="color: red;"></i>
        </span>
    </button>
</mat-dialog-actions>